import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationModel } from 'src/app/models/notification.model';

@Component({
  selector: 'app-balloon-notification',
  templateUrl: './balloon-notification.component.html',
  styleUrls: ['./balloon-notification.component.scss'],
})
export class BalloonNotificationComponent implements OnInit {
  message: string;
  parent: HTMLElement;
  useAlternatives = false;
  timer: any;

  @ViewChild('host') host: ElementRef;
  side: number;
  alternativesAvailable = false;
  visible = false;
  top = 0;
  left = 0;

  constructor(
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef
  ) {}

  get rightside(): boolean {
    return this.side === 1;
  }

  ngOnInit() {
    this.notificationService.balloonNotification$.subscribe((notification: NotificationModel) => {
      this.reset();
      if (!!notification && !!notification.text) {
        this.message = this.translateService.instant(notification.text);

        if (notification.parent) {
          if (this.fitsInParent(notification)) {
            return;
          }

          this.parent = notification.parent;
          this.side = notification.side;
          this.useAlternatives = notification.alternatives;
        }
        setTimeout(() => {
          this.visible = true;
        }, 5);

        setTimeout(() => {
          this.setBalloonLocation();
        }, 10);

        if (notification.timeout) {
          this.setTimeout(notification.timeout);
        }
      }
    });

    this.notificationService.hideBalloonNotification$.subscribe((id: string) => {
      if (this.parent && this.parent.id === id) {
        this.visible = false;
        this.parent = undefined;
        this.useAlternatives = false;
      }
    });
  }

  fitsInParent(notification: NotificationModel) {
    const measureSpan = document.createElement('span');
    notification.parent.appendChild(measureSpan);
    measureSpan.style.opacity = '0';
    measureSpan.style.left = '0';
    measureSpan.style.position = 'fixed';

    measureSpan.innerText = this.message;
    measureSpan.setAttribute('class', 'button-description');

    this.cd.detectChanges();
    const fitsInParent =
      measureSpan.clientWidth / 2 < notification.parent.clientWidth - notification.parent.offsetLeft * 2;
    notification.parent.removeChild(measureSpan);
    this.cd.detectChanges();

    return fitsInParent;
  }

  reset() {
    this.visible = false;
    this.parent = undefined;
    this.useAlternatives = false;
    this.cancelTimout();
  }

  setTimeout(timeout: number) {
    this.timer = setTimeout(() => {
      this.visible = false;
      this.parent = undefined;
    }, timeout);
  }

  cancelTimout() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  setBalloonLocation() {
    if (this.parent) {
      let position: any;
      switch (this.side) {
        case 0:
          position = this.getBalloonLocationForTop(this.parent);
          break;
        case 1:
          position = this.getBalloonLocationForRight(this.parent);
          break;
      }

      if (position !== undefined) {
        (this.host.nativeElement as Element).getBoundingClientRect();
        this.top = position[0];
        this.left = position[1];
      }
    } else {
      return;
    }
  }

  getBalloonLocationForTop(target: HTMLElement): number[] {
    const rect = target.getBoundingClientRect();
    const hostRect = (this.host.nativeElement as Element).getBoundingClientRect();
    const middle = rect.left + rect.width / 2;
    return [rect.top - 8 - hostRect.height, middle - hostRect.width / 2];
  }

  getBalloonLocationForRight(target: HTMLElement): number[] {
    const rect = target.getBoundingClientRect();
    const hostRect = (this.host.nativeElement as Element).getBoundingClientRect();
    const middle = rect.top + rect.height / 2;

    return [middle - hostRect.height / 2, rect.left + rect.width + 8];
  }
}
